import { render } from "./ServiziDataTable.vue?vue&type=template&id=cc57f3d6"
import script from "./ServiziDataTable.vue?vue&type=script&lang=js"
export * from "./ServiziDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__